<template>
  <div class="d-flex field-select">
    <div :style="{ 'pointer-events': disabled ? 'none' : 'all' }" style="width: 48px" class="c-pointer" @click="previous()">
      <div v-if="showPrevious" class="tertiary">
        <v-icon color="white" x-large class="my-3 mx-1">
          chevron_left
        </v-icon>
      </div>
    </div>
    <div id="select-field-step-3" class="d-flex flex-grow-1 justify-center align-center text-title mb-0">
      {{ current }} of {{ total }} {{ type }}
      <v-btn v-if="!isReadOnly" icon @click="$emit('help')">
        <v-icon color="primary" class="ml-1">
          info_outline
        </v-icon>
      </v-btn>
    </div>
    <div :style="{ 'pointer-events': disabled ? 'none' : 'all' }" style="width: 48px" class="c-pointer" @click="next()">
      <div v-if="type === 'fields' || showNext" id="select-field-step-2" class="tertiary">
        <v-icon color="white" x-large class="my-3 mx-1">
          {{ showNext ? 'chevron_right' : 'check' }}
        </v-icon>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isReadOnly: { type: Boolean, default: false },
    current: { type: Number, default: 1 },
    total: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    type: { type: String, required: true }
  },
  computed: {
    showNext() {
      return this.total > this.current
    },
    showPrevious() {
      return this.current > 1
    }
  },
  methods: {
    previous() {
      this.$emit('back')
    },
    next() {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.field-select {
  border-top: 1px solid var(--v-tertiary-base);
  border-bottom: 1px solid var(--v-tertiary-base);
  height: 66px;
}
</style>
